<mat-nav-list>
    <ng-container *ngFor="let modulo of modulosIndex">
      <!-- Se o menu estiver no modo colapsado (lateral), mostra somente os ícones com MatMenu -->

      <ng-container *ngIf="isLateral; else expandedTemplate">
        <a mat-list-item [matMenuTriggerFor]="menu" matTooltip="{{ modulo.nome }}" [ngClass]="{'active-module': selectedModule === modulo}" class="item-menu" (click)="toggleModule(modulo)">
          <mat-icon mat-list-icon fontSet="material-symbols-rounded">
            {{ modulo.icone }}
          </mat-icon>
        </a>
        <!-- MatMenu para as funcionalidades deste módulo -->

        <mat-menu #menu="matMenu" class="menu-lateral">
          <ng-container *ngFor="let funcionalidade of modulo.funcionalidades">
            <button mat-menu-item [routerLink]="funcionalidade.route">
              {{ funcionalidade.nome }}
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
  
      <!-- Template para o modo expandido, onde exibe nome e submenu inline -->
      <ng-template #expandedTemplate>
        <a mat-list-item (click)="toggleModule(modulo)" [ngClass]="{'active-module': selectedModule === modulo}" class="item-menu">
          <mat-icon mat-list-icon fontSet="material-symbols-rounded">
            {{ modulo.icone }}
          </mat-icon>
          <span mat-line>{{ modulo.nome }}</span>
        </a>
        <!-- Submenu inline somente se o módulo estiver selecionado -->
        <div class="submenu" *ngIf="selectedModule === modulo">
          <mat-nav-list>
            <a mat-list-item *ngFor="let funcionalidade of modulo.funcionalidades" [routerLink]="funcionalidade.route">
              <span mat-line> {{ funcionalidade.nome }}</span>
            </a>
          </mat-nav-list>
        </div>
      </ng-template>
    </ng-container>
  </mat-nav-list>
  